import React from 'react';

import { connect } from 'react-redux';
import { State } from 'common/interfaces/state';
import { ConfirmationDialog } from 'components/dialog/confirmation-dialog';


export const DELETE_COMPANY_DIALOG = 'DELETE_COMPANY_DIALOG';

interface StateProps {
  companyId: string;
}

interface Props extends StateProps {
  onDeleteCompany: (companyId) => void;
}

const DeleteCompanyConfirmationDialogComponent: React.FC<Props> = (props) => {
  const onConfirm = React.useCallback(() => {
    props.onDeleteCompany(props.companyId);
  }, [props.onDeleteCompany, props.companyId]);

  return (
    <ConfirmationDialog
      name={DELETE_COMPANY_DIALOG}
      title={`Are you sure!?`}
      text={`Do you really want to delete the company(id:${props.companyId}) ??`}
      cancelButtonText='NOOOOO'
      confirmButtonText='DELETE'
      onConfirm={onConfirm}
    />
  );
};

const mapStateToProps = (state: State): StateProps => {
  return {
    companyId: state.dialog[DELETE_COMPANY_DIALOG],
  };
};


export const DeleteCompanyConfirmationDialog = connect(
  mapStateToProps,
  {},
)(DeleteCompanyConfirmationDialogComponent);
